// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"c48d740a","539":"95425326"}[chunkId] + ".chunk.js";
};